import React from 'react'
import Card from '../shared/card/card.jsx'
import root from '../shared/utils'
import {getOrdinalDate} from '../shared/enums/date-parser'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'

const NextScheduledJob = ({card, btnOnClick, noPullDown, hideBtnOnClick}) => {
  let NextScheduledJobType = getTaskTypeIconParser(card.taskType)
  let midIconRoot = root + '/common/latest/images/consumer/status-icons/'
  let midIcon = midIconRoot + 'SCHEDULED.png'
  let rightIcon = NextScheduledJobType.iconsrc
  let date = getOrdinalDate(card.millisDate)
  let moduleType = card.moduleType
  let btnText = hideBtnOnClick ? '' : 'More Details'
  return (
    <Card
      headerTitle={card.header}
      headerLeftIcon={card.date}
      headerMidIcon={midIcon}
      headerRightIcon={rightIcon}
      headerSubtitle={date}
      moduleType={moduleType}
      btnText={btnText}
      btnStyle='btn btn-sm btn-info'
      btnId='nextScheduledCard'
      btnOnClick={btnOnClick}
      noPullDown={noPullDown}>
      <p dangerouslySetInnerHTML={{ __html: card.content }} />
    </Card>
  )
}

NextScheduledJob.propTypes = {
  card: React.PropTypes.object.isRequired,
  btnOnClick: React.PropTypes.func.isRequired,
  noPullDown: React.PropTypes.bool,
  hideBtnOnClick: React.PropTypes.bool

}
export default NextScheduledJob



// WEBPACK FOOTER //
// ./src/components/dashboard/next-scheduled-job-card.jsx